<template>
  <v-dialog v-model="showAllCommentDialog" scrollable max-width="900px" persistent>
    <v-card>
      <v-toolbar color="white" fixed>
        <h3>{{ $i18n.t("All Comments") }}</h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <all-comments :comments="comments"></all-comments>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import { Vue, Component } from "vue-property-decorator";
import AllComments from "@/views/comment/AllComments.vue";

@Component({
  name: "AllCommentsDialog",
  props: {
    showAllCommentDialog: {
      default: null,
    },
    comments: {
      default: null,
    },
  },
  components: {
    AllComments,
  },
})
export default class AllCommentsDialog extends (Vue, Themeable) {
  closeDialog() {
    this.$emit("closeCommentDialog", true);
  }
//   @Watch("showAllCommentDialog")
//   onDialogValChange(val) {
//     this.showAllCommentDialog = val;
//   }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}

.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 100px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
.actionBox {
  position: sticky;
  background: white;
  bottom: 0px;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-top: 1px solid #dfdfdf;
  padding: 10px;
}
</style>
